import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ManualPaymentFilter,
  ManualPaymentResponse,
  ManualPaymentData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class ManualPaymentService {
  constructor(private http: HttpClient) {}

  listPayment(filter: ManualPaymentFilter): Observable<ManualPaymentResponse> {
    let params = new HttpParams();

    if (filter.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.email) {
      params = params.append('email', filter.email.toString());
    }

    if (filter.bank) {
      params = params.append('bank', filter.bank.toString());
    }

    if (filter.nominal) {
      params = params.append('nominal', filter.nominal.toString());
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ManualPaymentResponse>(
      environment.apiUrl + 'clientapi/manual-payment',
      { params }
    );
  }

  savePayment(data: ManualPaymentData): Observable<any> {
    return this.http.put(environment.apiUrl + 'clientapi/manual-payment', data);
  }
}
